//This is needed to change the underscore.js template syntax from % to @
//Otherwise the % sign will interfer with the .jsp
_.templateSettings = {
  interpolate: /\<\@\=(.+?)\@\>/gim,
  evaluate: /\<\@(.+?)\@\>/gim,
  escape: /\<\@\-(.+?)\@\>/gim
};
